import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    sessionScope: {},
}

export const sessionSlice = createSlice({
    name: 'sessionData',
    initialState,
    reducers: {
      setSessionData: (state, action) => {
        state.sessionScope = action.payload
      },
    },
  })


export const { setSessionData } = sessionSlice.actions;

export default sessionSlice.reducer